import { render, staticRenderFns } from "./SeniorMemberReport.vue?vue&type=template&id=0c0fa9d8"
import script from "./SeniorMemberReport.vue?vue&type=script&lang=js"
export * from "./SeniorMemberReport.vue?vue&type=script&lang=js"
import style0 from "./SeniorMemberReport.vue?vue&type=style&index=0&id=0c0fa9d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports